googletag.cmd.push(function() {
    var dfp_log = localStorage.getItem('dfp_debug') ? console.info.bind(console) : function() {};

    var pageType = (function() {
        var $h = $(document.documentElement);

        if ($h.hasClass('page-home')) {
            return 'home';
        }

        if ($h.hasClass('page-article')) {
            return 'article';
        }

        return 'other';
    })();

    var hidden = [[
        [0, 0], []
    ]];

    var globalSizeMappings = {
        4: [[
            [980, 90], [[980, 300], [980, 250], [980, 200], [980, 150], [980, 100], [970, 250], [970,  90], [960, 300], [960, 250], [960, 200], [960, 150], [960, 100], [728,  90]]
        ], [
            [728, 90], [[728,  90], [640, 300], [640, 250], [640, 200], [640, 150], [640, 100]]
        ], [
            [641, 100],  [[640, 300], [640, 250], [640, 200], [640, 150], [640, 100]]
        ], [
            [0, 0], []
        ]],
        5: [[
            [1200, 0], [1, 1]
        ], [
            [0, 0], []
        ]],
        8: [[
            [1200, 0], []
        ], [
            [641, 0], [1, 1]
        ], [
            [0, 0], []
        ]],
        9: [[
            [1200, 0], []
        ], [
            [641, 0], []
        ], [
            [320, 0], [1, 1]
        ], [
            [0, 0], []
        ]],
        10: [[
            [1200, 0], [1, 1]
        ], [
            [0, 0], []
        ]]
    };

    var sizeMappings = {
        home: {
            1: {
                desktop: [[
                    [769, 600], [[300, 250], [300, 600]]
                ], [
                    [0, 0], []
                ]],
                tablet: [[
                    [769, 250], []
                ], [
                    [641, 250], [300, 250]
                ], [
                    [0, 0], []
                ]],
                phone: [[
                    [641, 250], []
                ], [
                    [300, 250], [[300, 250], [320, 100], [320, 50]]
                ], [
                    [0, 0], []
                ]]
            },
            2: {
                desktop: [[
                    [769, 250], [300, 250]
                ], [
                    [0, 0], []
                ]],
                tablet: [[
                    [769, 250], []
                ], [
                    [641, 250], [300, 250]
                ], [
                    [0, 0], []
                ]],
                phone: [[
                    [769, 250], []
                ], [
                    [641, 250], []
                ], [
                    [300, 250], [300, 250]
                ], [
                    [0, 0], []
                ]]
            },
            3: {
                desktop: [[
                    [769, 250], [300, 250]
                ], [
                    [0, 0], []
                ]],
                tablet: hidden,
                phone: [[
                    [769, 250], []
                ], [
                    [641, 250], []
                ], [
                    [300, 250], [300, 250]
                ], [
                    [0, 0], []
                ]]
            },
            6: {
                desktop: hidden,
                tablet: hidden,
                phone: hidden
            },
            7: {
                desktop: hidden,
                tablet: hidden,
                phone: hidden
            }
        },
        article: {
            1: {
                desktop: [[
                    [769, 600], [[300, 250], [300, 600]]
                ], [
                    [0, 0], []
                ]],
                tablet: [[
                    [769, 250], []
                ], [
                    [641, 250], [300, 250]
                ], [
                    [0, 0], []
                ]],
                phone: [[
                    [641, 250], []
                ], [
                    [300, 250], [[300, 250], [320, 100], [320, 50]]
                ], [
                    [0, 0], []
                ]]
            },
            2: {
                desktop: [[
                    [769, 250], [300, 250]
                ], [
                    [0, 0], []
                ]],
                tablet: hidden,
                phone: hidden
            },
            3: {
                desktop: [[
                    [769, 250], [300, 250]
                ], [
                    [0, 0], []
                ]],
                tablet: hidden,
                phone: [[
                    [769, 250], []
                ], [
                    [641, 250], []
                ], [
                    [300, 250], [300, 250]
                ], [
                    [0, 0], []
                ]]
            },
            6: {
                desktop: [[
                    [769, 250], [300, 250]
                ], [
                    [0, 0], []
                ]],
                tablet: [[
                    [769, 250], []
                ], [
                    [641, 250], [300, 250]
                ], [
                    [0, 0], []
                ]],
                phone: [[
                    [641, 250], []
                ], [
                    [300, 250], [300, 250]
                ], [
                    [0, 0], []
                ]]
            },
            7: {
                desktop: [[
                    [960, 250], [300, 250]
                ], [
                    [0, 0], []
                ]],
                tablet: [[
                    [769, 250], []
                ], [
                    [641, 250], [300, 250]
                ], [
                    [0, 0], []
                ]],
                phone: hidden
            }
        },
        other: {
            1: {
                desktop: [[
                    [769, 600], [[300, 250], [300, 600]]
                ], [
                    [0, 0], []
                ]],
                tablet: [[
                    [769, 250], []
                ], [
                    [641, 250], [300, 250]
                ], [
                    [0, 0], []
                ]],
                phone: [[
                    [641, 250], []
                ], [
                    [300, 250], [[300, 250], [320, 100], [320, 50]]
                ], [
                    [0, 0], []
                ]]
            },
            2: {
                desktop: [[
                    [769, 250], [300, 250]
                ], [
                    [0, 0], []
                ]],
                tablet: [[
                    [769, 250], []
                ], [
                    [641, 250], [300, 250]
                ], [
                    [0, 0], []
                ]],
                phone: [[
                    [769, 250], []
                ], [
                    [641, 250], []
                ], [
                    [300, 250], [300, 250]
                ], [
                    [0, 0], []
                ]]
            },
            3: {
                desktop: [[
                    [769, 250], [300, 250]
                ], [
                    [0, 0], []
                ]],
                tablet: hidden,
                phone: [[
                    [769, 250], []
                ], [
                    [641, 250], []
                ], [
                    [300, 250], [300, 250]
                ], [
                    [0, 0], []
                ]]
            },
            6: {
                desktop: hidden,
                tablet: hidden,
                phone: hidden
            },
            7: {
                desktop: hidden,
                tablet: hidden,
                phone: hidden
            }
        }
    };

    var pagePositions = {
        home: [1, 2, 3, 4, 5, 8, 9, 10],
        article: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        other: [1, 2, 3, 4, 5, 8, 9, 10]
    };

    var bannerSizes = {
        1: [[300, 600], [300, 250], [320, 100], [320, 50]],
        2: [300, 250],
        3: [300, 250],
        4: [[980, 300], [980, 250], [980, 200], [980, 150], [980, 100], [970, 250], [970, 90], [960, 300], [960, 250], [960, 200], [960, 150], [960, 100], [728,  90], [640, 300], [640, 250], [640, 200], [640, 150], [640, 100]],
        5: [1, 1],
        6: [300, 250],
        7: [300, 250],
        8: [1, 1],
        9: [1, 1],
        10: [1, 1]
    };

    function getArgsDebug(args) {
        var text = JSON.stringify(args).substr(1);
        return text.substr(0, text.length - 1);
    }

    function defineSlot(id, div_id, sizeMapping) {
        var bannerSize = bannerSizes[id];
        var isOutOfPage = (bannerSize[0] === 1 && bannerSize[1] === 1);
        var args = [
            WMG.dfp_tags[id]
        ];

        if (!isOutOfPage) {
            args.push(bannerSize);
        }

        args.push(div_id);

        dfp_log('DFP: googletag.' + (isOutOfPage ? 'defineOutOfPageSlot' : 'defineSlot') + '(' +
            getArgsDebug(args) + ').defineSizeMapping(' + JSON.stringify(sizeMapping) +
            ').addService(googletag.pubads());');

        return googletag[isOutOfPage ? 'defineOutOfPageSlot' : 'defineSlot'].apply(googletag, args)
            .defineSizeMapping(sizeMapping)
            .addService(googletag.pubads());
    }

    pagePositions[pageType].forEach(function(banner_id) {
        if (WMG.banner_types[banner_id].type !== 'DFP') {
            return;
        }

        var sizeMappingParams = sizeMappings[pageType][banner_id];

        if (sizeMappingParams) {
            var devices = Object.keys(sizeMappingParams);

            devices.forEach(function(device) {
                defineSlot(banner_id, 'gpt-banner-' + banner_id + '-' + device, sizeMappingParams[device]);
            });

            return;
        }

        var globalSizeMapping = globalSizeMappings[banner_id];

        if (globalSizeMapping) {
            defineSlot(banner_id, 'gpt-banner-' + banner_id, globalSizeMapping);
        }
    });

    if (WMG.dfp_section) {
        dfp_log('DFP: ' + 'googletag.pubads().setTargeting("section", "' + WMG.dfp_section + '")');
        googletag.pubads().setTargeting('section', WMG.dfp_section);
    }

    if (WMG.dfp_article) {
        dfp_log('DFP: ' + 'googletag.pubads().setTargeting("article", "' + WMG.dfp_article + '")');
        googletag.pubads().setTargeting('article', WMG.dfp_article);
    }

    if (WMG.dfp_article_tags) {
        dfp_log('DFP: ' + 'googletag.pubads().setTargeting("tags", "[' + WMG.dfp_article_tags.join(',') + ']")');
        googletag.pubads().setTargeting('tags', WMG.dfp_article_tags);
    }

    if (WMG.dfp_gender) {
        dfp_log('DFP: ' + 'googletag.pubads().setTargeting("gender", "' + WMG.dfp_gender + '")');
        googletag.pubads().setTargeting('gender', WMG.dfp_gender);
    }

    if (WMG.dfp_age) {
        dfp_log('DFP: ' + 'googletag.pubads().setTargeting("age", "' + WMG.dfp_age + '")');
        googletag.pubads().setTargeting('age', WMG.dfp_age);
    }

    if (WMG.dfp_location) {
        dfp_log('DFP: ' + 'googletag.pubads().setTargeting("location", "' + WMG.dfp_location + '")');
        googletag.pubads().setTargeting('location', WMG.dfp_location);
    }

    if (WMG.hasOwnProperty('dfp_adult') && WMG.dfp_adult) {
        dfp_log('DFP: ' + 'googletag.pubads().setTargeting("adult", "yes")');
        googletag.pubads().setTargeting('adult', 'yes');
    } else {
        dfp_log('DFP: ' + 'googletag.pubads().setTargeting("adult", "no")');
        googletag.pubads().setTargeting('adult', 'no');
    }

    if (WMG.dfp_sync) {
        dfp_log('DFP: ' + 'googletag.pubads().enableSyncRendering()');
        googletag.pubads().enableSyncRendering();
    }
    else {
        if (navigator.userAgent.indexOf('iPad') === -1 && navigator.userAgent.indexOf('iPhone') === -1) {
            dfp_log('DFP: ' + 'googletag.pubads().enableSingleRequest()');
            googletag.pubads().enableSingleRequest();
        }
    }

    dfp_log('DFP: ' + 'googletag.pubads().collapseEmptyDivs(true)');
    googletag.pubads().collapseEmptyDivs(true);

    dfp_log('DFP: ' + 'googletag.enableServices()');
    googletag.enableServices();
});
